import doubleDigitize from 'src/filters/doubleDigitize';

export default (inputDate) => {
  if (!inputDate) return '';

  const date = inputDate instanceof Date ? inputDate : new Date(inputDate);
  if (typeof inputDate === 'number') date.setTime(inputDate * 1000);
  if (Number.isNaN(Number(date))) date.setTime(new Date(inputDate.replace(' ', 'T')));

  const DD = date.getDate();
  const MM = date.getMonth() + 1;
  const YYYY = date.getFullYear();
  const h = date.getHours();
  const m = doubleDigitize(date.getMinutes());
  const s = doubleDigitize(date.getSeconds());

  return `${DD}/${MM}/${YYYY}, ${h}:${m}:${s}`;
};
